import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {

  /*
  date format pipe to return date in 
  format MM/dd/yyyy
  */

  override transform(value: any, _args?: any): any {
    return super.transform(value, 'MM/dd/yyyy');
  }

}
